import { Controller } from 'stimulus';
import { t } from '../javascript/lib/i18n';

/**
 * For showing confirmation popups for link & forms we should use turbo's `data-turbo-confirm` attribute
 *
 * There are some instances in the app where these links/forms have `data-turbo-false="true"` set.
 * In this case the confirmation won't show so we can use this controller instead. Some of our elements
 * conditionally apply `data-turbo-false="true"` so this code only runs if turbo is disabled.
 *
 * Attach to the `<form>` element generated by a `button_to` helper
 */
export default class extends Controller {
  connect() {
    this.element.addEventListener('submit', (event) => {
      if (!this.isTurboDisabled(event)) return;

      const confirmMessage =
        this.element.dataset.turboConfirm ||
        t('js.confirm_dialog.are_you_sure');
      const confirmed = confirm(confirmMessage);

      if (!confirmed) event.preventDefault();
    });
  }

  isTurboDisabled(event) {
    return (
      event.submitter.dataset.turbo === 'false' ||
      this.element.dataset.turbo === 'false'
    );
  }
}
